<!-- 设备类型：积温积光仪；type：37；设备品牌：优联。 -->
<template>
  <main class="device-development">设备详情页正在开发中</main>
</template>

<script>
export default {
  name: 'AccumulatedTemperatureLight'
}
</script>

<style scoped>
.device-development {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 16px 16px calc(16px + env(safe-area-inset-bottom));
  background: #F2F7FC;
  color: #8096AD;
  font-size: 16px;
}
</style>
